import { CLEOS_REPORTS_API_BASE, CLEOS_REPORTS_API_VERSION } from 'config';
import { createHttpClient } from './utils';

export default createHttpClient(`${CLEOS_REPORTS_API_BASE}${CLEOS_REPORTS_API_VERSION}`, {
  convertEmptyStrings: false,
});
